module.exports = __webpack_public_path__ + "static/media/PastoralCare.15b21706.jpg";